<template>
  <div>
    <h2 class="title">{{ title }}</h2>
  </div>
</template>

<script>
  export default {
    name: 'title',
    props: {
      title: {
        type: String,
        required: true
      }
    },
    data () {
      return {}
    }
  }
</script>

<styles>

</styles>



// WEBPACK FOOTER //
// PageTitle.vue?0a7d643c